import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
} from "@mui/material";

const nombreClienteFromRow = (row) =>
  row?.clienteNombre ?? row?.nombreCliente ?? row?.cliente?.nombre ?? "este cliente";

export default function ConfirmVentaDialog({ open, cliente, onClose, onAction }) {
  const nombreCliente = nombreClienteFromRow(cliente);

  return (
    <Dialog open={Boolean(open)} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>Registrar venta</DialogTitle>
      <DialogContent>
        <Box sx={{ mt: 1, display: "flex", flexDirection: "column", gap: 1 }}>
          <Typography variant="body1">
            ¿Quieres registrar una venta para {nombreCliente}?
          </Typography>
          <Typography variant="body2" sx={{ opacity: 0.8 }}>
            Si ignoras, pasarás al cuadro para elegir la puntuación sin registrar datos de venta.
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => onAction?.("cancel")}>Cancelar</Button>
        <Button onClick={() => onAction?.("ignorar")}>Ignorar</Button>
        <Button variant="contained" onClick={() => onAction?.("registrar")}>
          Registrar venta
        </Button>
      </DialogActions>
    </Dialog>
  );
}
